import { ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { guard } from "../../../guards/guard";
import { TypeActionExpansions } from "../actionExpansions";
import { checkHasMissingResources } from "../checks/checkHasMissingResources";
import { pathBuyExpansion } from "../paths/pathBuyExpansion";
import { pathNotEnoughResource } from "../paths/pathNotEnoughResource";
export var epicExpansionsBuyStandardPurchase = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionExpansions.RequestBuyStandard), map(function (action) { return action; }), guard(state$, deps, pathBuyExpansion)([checkHasMissingResources(pathNotEnoughResource)]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/epics/epicExpansionsBuyStandardPurchase.ts
// module id = 2097
// module chunks = 3